import useSubmit from '../../../../../elements/Hooks/useSubmit'
import { get, isEmpty } from 'lodash'
import React, { Component } from 'react'
import { Alert, Button, Col, Modal, Popconfirm, Row, Tabs } from 'antd'
import TransactionForm from '../Forms/TransactionForm'
import Documents from '../../../../Common/Documents/DocumentsCont'
import AllocationForm from '../Forms/AllocationForm'
import Transactions from '../../../../../api/Finance/Transactions'

const { TabPane } = Tabs
const api = new Transactions()

function TransactionModal(props) {
  const {
    visible,
    type,
    transaction = {},
    onCancel,
    submitting,
    fetchingTransaction,
    submit,
    formRef,
    formAllocateRef,
    update,
    remove,
    fetch,
    removing,
  } = props

  const [Splitting, onSplit] = useSubmit(async () => {
    await api.makeGroupTransactionFromStripe(transaction._key)
    fetch()
    onCancel()
  })

  const isGroupTransaction = get(transaction, 'transactionType') === 'Group Transaction'

  return (
    <Modal
      title={type !== 'edit' ? 'Record Transaction' : 'Update Transaction'}
      destroyOnClose={true}
      visible={visible}
      onCancel={onCancel}
      width={'95%'}
      footer={
        (type === 'edit' && transaction.status === 'Submitted') || type === 'new' ? (
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button loading={submitting} type="primary" onClick={type !== 'edit' ? submit : update}>
                {type === 'edit' ? 'Update' : 'Submit'}
              </Button>
              {type === 'edit' && (
                <Popconfirm
                  title="Are you sure remove this transaction?"
                  onConfirm={remove}
                  okText="Yes"
                  cancelText="No">
                  <Button type="danger" loading={removing} style={{ marginLeft: 8 }}>
                    Remove
                  </Button>
                </Popconfirm>
              )}
            </Col>
          </Row>
        ) : null
      }>
      {!transaction.isStripe && get(transaction, 'receipt.type') === 'stripe-payment' && (
        <Button loading={Splitting} type="primary" onClick={onSplit}>
          Make As Group Transactions
        </Button>
      )}
      {isGroupTransaction && <Alert message="This is a Group Transaction" type="info" showIcon />}
      <Tabs defaultActiveKey="details">
        <TabPane tab="Details" key="details">
          <TransactionForm ref={formRef} loading={fetchingTransaction} transaction={transaction} {...props} />
        </TabPane>
        <TabPane disabled={type !== 'edit'} tab="Files" key="files">
          <Documents
            editable={transaction.status === 'Submitted' || transaction.status === 'Draft'}
            footer={false}
            category={false}
            owner={transaction}
            loading={fetchingTransaction}
          />
        </TabPane>
        <TabPane disabled={type !== 'edit'} tab="Allocation" key="allocation">
          <AllocationForm ref={formAllocateRef} loading={fetchingTransaction} {...props} />
        </TabPane>
      </Tabs>
    </Modal>
  )
}

export default TransactionModal
